export function getApiErrorMessage(error) {
    const data = error?.response?.data;
    if (data == null)
        return undefined;
    if (typeof data === "string" && data.trim())
        return data.trim();
    if (typeof data !== "object")
        return undefined;
    const d = data;
    const message = d.message;
    if (typeof message === "string" && message.trim())
        return message.trim();
    const detail = d.detail;
    if (typeof detail === "string" && detail.trim())
        return detail.trim();
    if (Array.isArray(detail) && detail.length > 0) {
        const first = detail[0];
        if (typeof first === "string")
            return first;
        if (first && typeof first === "object" && "msg" in first) {
            const m = first.msg;
            if (typeof m === "string" && m.trim())
                return m.trim();
        }
    }
    // Ошибка с кодом: `detail` — ОБЪЕКТ `{ code, message }` (подписочные ошибки).
    // Берём из него текст; без этой ветки объект пришлось бы печатать как есть
    // («[object Object]»), а код без текста пользователю ничего не говорит.
    if (detail && typeof detail === "object" && !Array.isArray(detail)) {
        const m = detail.message;
        if (typeof m === "string" && m.trim())
            return m.trim();
    }
    return undefined;
}
/**
 * Стабильный код ошибки бэка в нижнем регистре (`subscription_already_active`).
 *
 * Подписочные ошибки api_public приходят как `{ detail: { code, message } }`
 * (detail — объект, код — В ВЕРХНЕМ регистре); остальные ошибки роутера и
 * авторизации — по-прежнему `{ detail: "строка" }`, кода у них нет. На случай
 * другой формы ответа смотрим ещё конверт `{ error: { code } }` и плоский
 * `code`. Регистр приводим к нижнему, чтобы сравнение от него не зависело.
 */
export function getApiErrorCode(error) {
    const data = error?.response?.data;
    if (!data || typeof data !== "object")
        return undefined;
    const d = data;
    const candidates = [
        d.detail?.code,
        d.error?.code,
        d.code,
    ];
    for (const code of candidates) {
        if (typeof code === "string" && code.trim())
            return code.trim().toLowerCase();
    }
    return undefined;
}
